module.exports = __webpack_public_path__ + "static/media/sarah.aeb952f9.png";